import type React from 'react'

/** Filled cursor icon for node-edit mode — shown when a path is selected for node editing. */
export const PenNodeEdit: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M4.04,4.69c-.11-.25,0-.54.26-.65.13-.05.27-.05.39,0l16,6.5c.26.1.38.4.27.65-.06.15-.18.26-.34.3l-6.12,1.58c-.7.18-1.26.73-1.44,1.43l-1.58,6.13c-.07.27-.34.43-.61.36-.15-.04-.28-.15-.34-.3L4.04,4.69Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)
